module.exports = __webpack_public_path__ + "img/tpc-29.269a34a2.webp";